export function formatOutlookDate(date: string): string {
  return new Date(`${date}T00:00:00`).toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
}

export function formatHomeDate(date: string): string {
  const value = new Date(`${date}T00:00:00`);
  const day = value.getDate();
  const suffix = day % 100 >= 11 && day % 100 <= 13
    ? 'th'
    : ({ 1: 'st', 2: 'nd', 3: 'rd' }[day % 10] || 'th');
  return `${formatOutlookDate(date)}${suffix}, ${value.getFullYear()}`;
}
